import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error) {    
      return { hasError: true };  
  }
  render() {
    if (this.state.hasError) {
        return <div>{this.props?.componentName} threw an Error</div>;
    }
    return this.props.children; 
  }
}

export default ErrorBoundary;
